import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is delivered exclusively via the httpOnly ``access_token`` cookie
// set by the backend on login/register/verify/reset. We never store the JWT
// in localStorage — keeping it out of JavaScript means a successful XSS
// payload cannot lift the session.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function naira(amount) {
  return `₦${Number(amount || 0).toLocaleString()}`;
}

/** Format an integer cents value as ``$1.23``. Handles missing/negative
 *  input gracefully by returning ``$0.00``. */
export function usd(cents) {
  const c = Number(cents || 0);
  if (!Number.isFinite(c) || c < 0) return "$0.00";
  return `$${(c / 100).toFixed(2)}`;
}
